import React from "react";
import DOMPurify from "dompurify";
import ScrollAnimation from 'react-animate-on-scroll';
import 'animate.css';
import MyCountdown from "../parts/countdown";
import Form from "../forms/form";
import LastImage from "../../img/hrws_gall_2.jpg";

const EventPanelBase = ({ panelData }) => {
    if (!panelData) return null;
    
    const { panel_title, panel_list } = panelData;

    return (
        <section className="py-20 relative bg-[#f3f4f5]">
            <div className="container mx-auto px-4">
                {/*<ScrollAnimation animateIn="animate__fadeInUp">*/}
                {/*    <h6 className="bg-[#F3FF80] w-max px-3 py-1 mb-4 rounded-2xl m-auto">*/}
                {/*        Експертні діалоги*/}
                {/*    </h6>*/}
                {/*</ScrollAnimation>*/}
                <ScrollAnimation animateIn="animate__fadeInUp" className="z-30 relative">
                    <h2 className="sm:text-4xl text-2xl mb-9 uppercase text-center">{panel_title}</h2>
                </ScrollAnimation>
            </div>
            <div className="container px-2 mx-auto rounded-2xl overflow-hidden relative z-30">
                <div className="grid sm:grid-cols-3 gap-4">
                    {panel_list.map((panel, index) => (
                        <div className="bg-[#feffca] rounded-xl overflow-hidden" key={index}>
                            <div className="w-full relative">
                                <img src={panel.img} className="h-full w-full object-cover"/>
                                <div className="w-full absolute -bottom-1 left-0">
                                    <svg className="w-full" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
                                        <path fill="#feffca" fill-opacity="1"
                                              d="M0,128L120,160C240,192,480,256,720,245.3C960,235,1200,149,1320,106.7L1440,64L1440,320L1320,320C1200,320,960,320,720,320C480,320,240,320,120,320L0,320Z"></path>
                                    </svg>
                                </div>
                            </div>
                            <div
                                className="w-full p-4">
                                <ScrollAnimation animateIn="animate__fadeInUp">
                                    <h3 className="uppercase mb-4 text-[1.1em] max-w-3xl">
                                        <span className="sm:hidden">{index + 1}.</span> {panel.title}</h3>
                                </ScrollAnimation>
                                <ScrollAnimation animateIn="animate__fadeInUp">
                                    <div className="panels-text"
                                        dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(panel.text, {sanitize: true})}}/>
                                </ScrollAnimation>
                            </div>

                        </div>
                    ))}
                    <div className="rounded-xl overflow-hidden" style={{background: 'linear-gradient(180deg, #262563 50%, #1b1464)'}}>
                        <div className="w-full relative">
                            <img src={LastImage} className="h-full w-full object-cover"/>
                            <div className="w-full absolute -bottom-1 left-0">
                                <svg className="w-full" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
                                    <path fill="#262563" fill-opacity="1"
                                          d="M0,128L120,160C240,192,480,256,720,245.3C960,235,1200,149,1320,106.7L1440,64L1440,320L1320,320C1200,320,960,320,720,320C480,320,240,320,120,320L0,320Z"></path>
                                </svg>
                            </div>
                        </div>
                        <div className="p-4 text-white">
                            <ScrollAnimation animateIn="animate__fadeInUp">
                                <h3 className="uppercase mb-4 text-[1.1em] max-w-3xl">Заповніть форму і отримайте
                                    спеціальну пропозицію</h3>
                            </ScrollAnimation>
                            <ScrollAnimation animateIn="animate__fadeInUp">
                                <MyCountdown/>
                                <Form nameform="form_uchast_intext_done"/>
                            </ScrollAnimation>
                        </div>

                    </div>
                </div>
            </div>
            <div className="absolute top-0 left-0 w-full">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
                    <path fill="#fff" fill-opacity="1"
                          d="M0,32L80,32C160,32,320,32,480,64C640,96,800,160,960,208C1120,256,1280,288,1360,304L1440,320L1440,0L1360,0C1280,0,1120,0,960,0C800,0,640,0,480,0C320,0,160,0,80,0L0,0Z"></path>
                </svg>
            </div>
        </section>
    );
}

export default EventPanelBase;